import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import styles from "./styles.module.scss";
import lanetalkLogo from "../../shared/images/logo192.png";
import { verifyAccount } from "../../services/loginService";
import { error, success } from "../components/toast/toast";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import themeStyles from "../../shared/styles/theme/theme-styles.module.scss";

const VerifyAccount = (props) => {
  const history = useHistory();
  const { code } = useParams();
  const [subtitle, setSubtitle] = useState("");
  const [errors, setErrors] = useState(null);
  const [loading, setLoading] = useState(false);
  const toastId = React.useRef(null);
  const dismissAll = () => {
    toast.dismiss();
  };

  useEffect(() => {
    setLoading(true);
    setSubtitle("Verifying account...");
    verifyHandler();
  }, []);

  const verifyHandler = () => {
    verifyAccount(code).then((res) => {
      if (res && res.error) {
        setErrors(res.error);
        let messageError =
          res.statusCode && res.statusCode === 403
            ? "Invalid verification code."
            : res.error;
        toastId.current = error(messageError, {
          autoClose: 15000,
          onClose: () => {
            window.removeEventListener("click", dismissAll);
          },
        });
        setSubtitle("Not verified.");
        window.addEventListener("click", dismissAll);
      } else {
        if (res) {
          if (res.success === true || res.statusCode === 200) {
            setSubtitle("Verified!");
            success("The account was activated successfully", {
              onClose: () => {
                history.push("/login");
              },
            });
          }
        }
      }
    });
  };

  return (
    <div className={styles.loginPage}>
      <div className={styles.joinOurCommunitySection}>
        <img src={lanetalkLogo} alt="" />
        <span className={styles.textLogo}>Lanetalk</span>
      </div>
      <div className={styles.loginSection}>
        <h3 className={themeStyles.headerSmInverted}>{subtitle}</h3>
      </div>
    </div>
  );
};

export default VerifyAccount;
